/* eslint-disable max-len */
export const GET_ENQUIRY_VIEWING_PERFORMANCE_REPORT_STATISTICS = 'GET_ENQUIRY_VIEWING_PERFORMANCE_REPORT_STATISTICS'
export const GET_ENQUIRY_VIEWING_PERFORMANCE_REPORT_STATISTICS_SUCCESS = 'GET_ENQUIRY_VIEWING_PERFORMANCE_REPORT_STATISTICS_SUCCESS'
export const GET_ENQUIRY_VIEWING_PERFORMANCE_REPORT_STATISTICS_FAILED = 'GET_ENQUIRY_VIEWING_PERFORMANCE_REPORT_STATISTICS_FAILED'

export const CLEAR_ENQUIRY_VIEWING_PERFORMANCE_REPORT_STATISTICS = 'CLEAR_ENQUIRY_VIEWING_PERFORMANCE_REPORT_STATISTICS'
